import { p as proxyCustomElement, H, h, F as Fragment, a as Host } from './index.js';
import { p as parseHrefProp } from './p-DlCOw5Kl.js';
import { d as defineCustomElement$c } from './p-BbTg3Car.js';
import { d as defineCustomElement$b } from './p-7jxIfyyn.js';
import { d as defineCustomElement$a } from './p-CE-SFMeF.js';
import { d as defineCustomElement$9 } from './p-BLpMhFGJ.js';
import { d as defineCustomElement$8 } from './p-BZccBFnt.js';
import { d as defineCustomElement$7 } from './p-Da2lAZSv.js';
import { d as defineCustomElement$6 } from './p-PXnlnivq.js';
import { d as defineCustomElement$5 } from './p-CEvUoLql.js';
import { d as defineCustomElement$4 } from './p-FpOQMZxV.js';
import { d as defineCustomElement$3 } from './p-CtbK9Pbz.js';
import { d as defineCustomElement$2 } from './p-cR96ip-k.js';
import { d as defineCustomElement$1 } from './p-Bn01tsA6.js';

const thumbnailCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:inline-flex;flex:none;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.container{align-items:center;background-color:var(--jw-theme-surface-level1-default-bg-color);color:var(--jw-theme-surface-text-disabled-color);display:flex;justify-content:center;outline-color:var(--jw-theme-surface-border-border-color);overflow:hidden;position:relative;transition:outline-color .15s ease}.container,.container:after{border-radius:.25rem;height:100%;width:100%}.container:after{content:\"\";outline-color:inherit;outline-offset:-1px;outline-style:solid;outline-width:1px;pointer-events:none;z-index:6}.container:after,a{inset:0;position:absolute}wui-icon{height:1.5rem;width:1.5rem}.blur-backdrop{filter:blur(2px);inset:0;opacity:.3;position:absolute;transform:scale(1.1)}.content,.fallback{inset:0;margin:auto;position:absolute;z-index:1}.content,wui-loader{transition:opacity .2s ease}.badge,.label,wui-check-input{opacity:0;position:absolute;transition:opacity .2s ease}.badge,.label{z-index:2}wui-check-input{left:.5rem;top:.5rem;z-index:4}.badge{bottom:.5rem;right:.5rem}.label{right:.5rem;top:.5rem}.hover-actions{inset:0;opacity:0;pointer-events:none;transition:opacity .2s ease,background-color .2s ease;width:100%;z-index:3}.hover-actions,.playlist-overlay{align-items:center;display:flex;height:100%;justify-content:center;position:absolute}.playlist-overlay{background-color:#000000b3;border-bottom-right-radius:.25rem;border-top-right-radius:.25rem;right:0;top:0;width:50%;z-index:5}.playlist-overlay>div{align-items:center;color:var(--jw-theme-surface-bold-link-inverted-default-color);display:flex;font-family:Open Sans;font-size:.875rem;font-weight:600;gap:.125rem;justify-content:center;letter-spacing:-.0004em;line-height:1.25rem}:host([loading]) wui-loader{opacity:1}:host([loading]) .badge,:host([loading]) .content,:host([loading]) .label{opacity:0}:host(:not([loading])) wui-loader{opacity:0}:host(:not([loading])) .badge,:host(:not([loading])) .content,:host(:not([loading])) .label{opacity:1}:host([error]) .container{background:var(--jw-theme-error-secondary-hover-bg-color);color:var(--jw-theme-error-primary-default-bg-color);outline-color:var(--jw-theme-error-secondary-border-color)}:host([checked]:not([disabled])) .container{outline-color:var(--jw-theme-system-primary-default-bg-color)}:host([is-placeholder]) .container{align-items:center;justify-content:center}:host(:not([loading]):not([disabled]):hover) .container[has-hover-actions],:host(:not([loading]):not([disabled]):hover) .container[has-href]{outline-color:var(--jw-theme-system-primary-default-bg-color)}:host(:not([loading]):not([disabled]):hover) .hover-actions{background-color:var(--jw-theme-surface-overlay-bg-color);opacity:.9;pointer-events:all}:host(:hover:not([disabled])) wui-check-input,:host([checked]) wui-check-input{opacity:1;pointer-events:all}:host([orientation=vertical][size=sm]){height:5.3333333333rem;width:3rem}:host([orientation=vertical][size=sm]) .content{height:auto;width:100%}:host([orientation=vertical][size=md]){height:8rem;width:4.5rem}:host([orientation=vertical][size=md]) .content{height:auto;width:100%}:host([orientation=vertical][size=lg]){height:16rem;width:9rem}:host([orientation=vertical][size=lg]) .content{height:auto;width:100%}:host([orientation=vertical][size=xl]){height:17.7777777778rem;width:10rem}:host([orientation=vertical][size=xl]) .content{height:auto;width:100%}:host([orientation=horizontal][size=sm]){height:3rem;width:5.3333333333rem}:host([orientation=horizontal][size=sm]) .content{height:100%;width:auto}:host([orientation=horizontal][size=md]){height:4.5rem;width:8rem}:host([orientation=horizontal][size=md]) .content{height:100%;width:auto}:host([orientation=horizontal][size=lg]){height:9rem;width:16rem}:host([orientation=horizontal][size=lg]) .content{height:100%;width:auto}:host([orientation=horizontal][size=xl]){height:10rem;width:17.7777777778rem}:host([orientation=horizontal][size=xl]) .content{height:100%;width:auto}";

const isVideo = (src) => {
    // All videos encoded at JWP use mp4 (I hope)
    return src?.endsWith('.mp4');
};
const WuiThumbnail = /*@__PURE__*/ proxyCustomElement(class WuiThumbnail extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Set error state
         */
        this.error = false;
        /**
         * Orientation
         */
        this.orientation = 'horizontal';
        /**
         * Alternative text for thumbnail
         */
        this.alt = '';
        /**
         * Preset size format for thumbnail
         */
        this.size = 'md';
        /**
         * Sets background blur for image
         */
        this.blurImage = false;
        /**
         * Disable any interaction
         */
        this.disabled = false;
        /**
         * Render a checkbox
         */
        this.checkable = false;
        /**
         * Set checkbox 'checked' value
         */
        this.checked = false;
        /**
         * Indicates item source resolve failure
         */
        this.srcError = false;
        this.handleSrcError = (_evt) => {
            this.srcError = true;
            this.loading = false;
        };
        this.handleSrcLoad = async () => {
            this.srcError = false;
            this.loading = false;
        };
        this.handleInput = (evt) => {
            evt.stopPropagation();
            if (this.disabled) {
                evt.preventDefault();
                return;
            }
            this.checked = !this.checked;
            this.el?.dispatchEvent(new window.Event('input', { bubbles: true }));
        };
        this.handleClick = (evt) => {
            // Use own event
            evt.preventDefault();
            evt.stopPropagation();
            this.el?.dispatchEvent(new window.Event('click', { bubbles: true }));
        };
    }
    _watchError(newValue) {
        if (newValue && this.loading) {
            this.loading = false;
        }
    }
    _watchSrc(newValue = this.src, oldValue = this.src) {
        if (newValue === oldValue) {
            return;
        }
        this.loading = true;
    }
    get sizePreset() {
        return typeof this.size === 'string' ? this.size : undefined;
    }
    get sizeWidth() {
        return typeof this.size === 'object' ? this.size.width : undefined;
    }
    get sizeHeight() {
        return typeof this.size === 'object' ? this.size.height : undefined;
    }
    renderAnchor(children) {
        return h("a", { ...parseHrefProp(this.href, this.disabled) }, children);
    }
    componentWillLoad() {
        this._watchSrc();
    }
    renderSrc() {
        // Error state prevents images from being loaded
        if (this.error) {
            return null;
        }
        let elm;
        if (isVideo(this.src)) {
            elm = (h("video", { autoPlay: true, loop: true, muted: true, controls: false, src: this.src, onPlay: this.handleSrcLoad, onError: this.handleSrcError, class: "content" }));
        }
        else {
            elm = (h("img", { onError: this.handleSrcError, onLoad: this.handleSrcLoad, class: "content", src: this.src, style: {
                    width: this.sizeWidth,
                    height: this.sizeHeight,
                }, alt: this.alt }));
        }
        return this.href ? this.renderAnchor(elm) : elm;
    }
    renderContent() {
        const isSmallSize = this.sizePreset && ['sm', 'md'].includes(this.sizePreset);
        const showLabel = typeof this.label !== 'undefined' && !isSmallSize;
        const showBadge = typeof this.badge !== 'undefined' && !isSmallSize;
        const badgeText = typeof this.badge === 'object' ? this.badge.label : this.badge;
        const badgeIcon = typeof this.badge === 'object' ? this.badge.icon : undefined;
        const showHoverActions = this.hoverActions && !this.href && !this.loading && !this.disabled && !isSmallSize;
        // We can't blur a video
        const blurImage = this.blurImage && !isVideo(this.src);
        return (h(Fragment, null, (() => {
            if (this.error) {
                return h("wui-icon", { name: "alert-circle", size: "xl" });
            }
            if (this.loading) {
                return h("wui-loader", null);
            }
            return (h(Fragment, null, this.srcError && h("wui-icon", { name: "photo-off" }), this.checkable && (h("wui-check-input", { checked: this.checked, disabled: this.disabled, onInput: this.handleInput })), showLabel && (h("div", { class: "label" }, h("wui-tag", { type: "neutral", message: "bold", label: this.label, title: this.label }))), showBadge && (h("div", { class: "badge" }, h("wui-tag", { type: "neutral", message: "bold", label: badgeText, title: badgeText, icon: badgeIcon }))), blurImage && h("div", { class: "blur-backdrop", style: { backgroundImage: `url(${this.src})` } }), showHoverActions && (h("wui-layout", { type: "button-group", class: "hover-actions" }, this.hoverActions?.map((action, idx) => {
                return (h("wui-button", { key: idx, ...action, intent: action.icon === 'trash' ? 'error' : action.intent, type: "tertiary" }));
            })))));
        })(), this.renderSrc()));
    }
    renderPlaceholder() {
        const isLargeSize = this.sizePreset && ['lg', 'xl'].includes(this.sizePreset);
        return (h("wui-button", { disabled: this.disabled, onClick: this.handleClick, icon: "plus", type: isLargeSize ? 'tertiary' : 'icon', label: isLargeSize ? 'Add' : undefined }));
    }
    render() {
        return (h(Host, { key: '527ebec8234d099281458675e33252ceaf5a6868', style: {
                width: this.sizeWidth,
                height: this.sizeHeight,
            } }, this.isPlaceholder ? (h("div", { class: "container" }, this.renderPlaceholder())) : (h("div", { class: "container", "has-src-error": this.srcError, "has-hover-actions": !!this.hoverActions, "has-href": !!this.href }, this.renderContent(), this.playlistCount && (h("div", { class: "playlist-overlay" }, h("div", null, h("wui-icon", { name: "list" }), this.playlistCount)))))));
    }
    get el() { return this; }
    static get watchers() { return {
        "error": ["_watchError"],
        "src": ["_watchSrc"]
    }; }
    static get style() { return thumbnailCss; }
}, [257, "wui-thumbnail", {
        "loading": [1540],
        "error": [516],
        "src": [1],
        "orientation": [513],
        "alt": [1],
        "size": [513],
        "blurImage": [4, "blur-image"],
        "label": [1],
        "badge": [1],
        "disabled": [516],
        "checkable": [4],
        "checked": [1540],
        "href": [1],
        "hoverActions": [16, "hover-actions"],
        "isPlaceholder": [4, "is-placeholder"],
        "playlistCount": [2, "playlist-count"],
        "srcError": [32]
    }, undefined, {
        "error": ["_watchError"],
        "src": ["_watchSrc"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-thumbnail", "wui-box", "wui-button", "wui-check-input", "wui-close-button", "wui-form-field", "wui-icon", "wui-layout", "wui-loader", "wui-status", "wui-tag", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-thumbnail":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiThumbnail);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tag":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiThumbnail as W, defineCustomElement as d };
